.hidden {
  display: none;
}
